import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { Grid } from "@mui/material/";
import CleansingMenu from "../Products/Product/Menu/CleansingMenu";
import { useLocation } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Rating from "@mui/material/Rating";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import { HashLink } from "react-router-hash-link";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import {
  storage,
  ref,
  uploadBytes,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject,
  addDoc,
  collection,
  db,
  serverTimestamp,
  deleteDoc,
  doc,
  setDoc,
} from "../../firebase";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { getDoc } from "firebase/firestore";
import { useTranslation } from "react-i18next";

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const ModifyAReview = () => {
  let location = JSON.parse(
    window.sessionStorage.getItem("iplookup")
  ).countryCode;

  location = "KO";

  const { t, i18n } = useTranslation();
  const [open2, setOpen2] = React.useState(false);
  const [value, setValue] = React.useState(5);
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [imageUrl, setImageUrl] = useState(undefined);
  const [imageUrl2, setImageUrl2] = useState(undefined);
  const [imageUrl3, setImageUrl3] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null);
  const [title, setTitle] = useState(null);
  const [comment, setComment] = useState(null);
  const { currentUser } = useAuth();
  let navigate = useNavigate();

  const [review, setReview] = useState(null);
  console.log("#### review ### ", review);

  let query = useQuery();
  let name = query.get("name");
  let link = query.get("link");
  let productId = query.get("productId");
  let id = query.get("id");

  console.log("id", id);

  const deleteReview = async () => {
    const reviewDb = location + "_" + "reviews_" + productId;
    await deleteDoc(doc(db, reviewDb, id));

    const userRef = doc(db, "users", currentUser.uid);
    const docSnap = await getDoc(userRef);

    if (docSnap.exists()) {
      let list = docSnap.data().reviews;
      console.log(list);
      console.log("id", reviewDb);
      // get the index of the id
      const index = list.indexOf(reviewDb);
      if (index > -1) {
        list.splice(index, 1); // 2nd parameter means remove one item only
      }

      setDoc(userRef, { reviews: list }, { merge: true });
      navigate(`/product/${link}#top`);
      window.scrollTo(0, 0);
    } else {
      navigate(`/product/${link}#top`);
      window.scrollTo(0, 0);
    }
  };

  useEffect(() => {
    const getDocFromDB = async () => {
      const reviewDb = location + "_" + "reviews_" + productId;

      const docRef = doc(db, reviewDb, id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setReview({ id: docSnap.id, ...docSnap.data() });
      } else {
        navigate(`/product/${link}#top`);
      }
    };
    getDocFromDB();
  }, []);

  useEffect(() => {
    if (review) {
      setValue(review.rating);
      setTitle(review.title);
      setComment(review.comment);
      console.log(review.images);
      if (review.images) {
        if (review.images[0]) {
          setImageUrl(review.images[0]);
        }
        if (review.images[1]) {
          setImageUrl2(review.images[1]);
        }
        if (review.images[2]) {
          setImageUrl3(review.images[2]);
        }
      }
    }
  }, [setReview, review]);

  const removeImage = (url) => {
    // Create a reference to the file to delete
    const desertRef = ref(storage, url);

    // Delete the file
    deleteObject(desertRef)
      .then(() => {
        if (url === imageUrl) {
          setImageUrl(undefined);
        } else if (url === imageUrl2) {
          setImageUrl2(undefined);
        } else {
          setImageUrl3(undefined);
        }
      })
      .catch((error) => {
        // Uh-oh, an error occurred!
      });
  };

  const upload = async (fileName) => {
    setLoading(true);
    const random = Math.floor(Math.random() * 100000000000000);
    const path = productId + "/";

    const storageRef = ref(storage, path + random);

    const uploadTask = uploadBytesResumable(storageRef, fileName);

    // Register three observers:
    // 1. 'state_changed' observer, called any time the state changes
    // 2. Error observer, called on failure
    // 3. Completion observer, called on successful completion
    await uploadTask.on(
      "state_changed",
      (snapshot) => {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload is " + progress + "% done");
        switch (snapshot.state) {
          case "paused":
            console.log("Upload is paused");
            break;
          case "running":
            console.log("Upload is running");
            break;
        }
      },
      (error) => {
        // Handle unsuccessful uploads
      },
      () => {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          // if (
          //   imageUrl !== undefined &&
          //   imageUrl2 !== undefined &&
          //   imageUrl3 !== undefined
          // ) {
          //   alert("Maximum number of photo is 3.");
          // }
          if (imageUrl === undefined) {
            setImageUrl(downloadURL);
          } else if (imageUrl2 === undefined) {
            setImageUrl2(downloadURL);
          } else if (imageUrl3 === undefined) {
            setImageUrl3(downloadURL);
          } else {
            setAlert("Maximum number of photo is 3.");
          }

          console.log("File available at", downloadURL);
        });
      }
    );
    setLoading(false);
  };

  const submit = async (e) => {
    e.preventDefault();
    console.log(value); // rating

    //timestamp: serverTimestamp()
    if (title && comment) {
      // Add a new document with a generated id.
      const dbName = location + "_" + "reviews_" + productId;

      let fn = "";
      let ln = "";
      let firstCharacterOfFirstname;

      const userRef = doc(db, "users", currentUser.uid);
      const docSnap = await getDoc(userRef);

      if (docSnap.exists()) {
        fn = docSnap.data().firstname;
        firstCharacterOfFirstname = fn.charAt(0);
        ln = docSnap.data().lastname;

        let data;
        if (docSnap.data().reviews) {
          data = docSnap.data().reviews;
          console.log("======= data", data);
          data.push(dbName);
        } else {
          data = [dbName];
        }

        console.log("currentUser.uid", currentUser.uid);

        const userRef = doc(db, "users", currentUser.uid);
        setDoc(userRef, { reviews: data }, { merge: true });
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }

      // put review to review db

      let images = [];
      if (imageUrl !== undefined) {
        images.push(imageUrl);
      }
      if (imageUrl2 !== undefined) {
        images.push(imageUrl2);
      }
      if (imageUrl3 !== undefined) {
        images.push(imageUrl3);
      }

      //// const docRef = await setDoc(doc(collection(db, "cities"), "SF"), {

      // const docRef = await setDoc(doc(collection(db, "cities"), "SF"), {}))

      const docRef = await setDoc(doc(collection(db, dbName), id), {
        title: title,
        comment: comment,
        rating: value,
        created: serverTimestamp(),
        images: images,
        uid: currentUser.uid,
        name: currentUser.email,
        type: "original",
      });

      // console.log("Document written with ID: ", docRef.id);
      handleClickOpen2(true);
      // navigate(`/product/${link}#top`);
    }
  };

  const handleClickOpen2 = () => {
    setOpen2(true);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };
  const goToAll = () => {
    ///dashboard-review
    navigate("/product/" + link + "#top");
    window.scrollTo(0, 0);
  };
  return (
    <>
      <Grid container sx={{ px: 10, mb: 10 }}>
        <Dialog
          open={open2}
          onClose={handleClose2}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {t("The review is edited successfully.")}
            <Box sx={{ display: "flex" }}>
              <button
                onClick={goToAll}
                className="custom_btn"
                style={{ margin: "20px", width: "400px" }}
              >
                {t("Go back to the product")}
              </button>

              <button
                className="custom_btn_whitebg"
                style={{ margin: "20px", width: "400px" }}
                onClick={handleClose2}
              >
                {t("Stay in this page")}
              </button>
            </Box>
          </DialogTitle>
        </Dialog>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {t("Are you sure you want to delete this review?")}
          </DialogTitle>
          {/* <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Let Google help apps determine location. This means sending
              anonymous location data to Google, even when no apps are running.
            </DialogContentText>
          </DialogContent> */}
          <DialogActions>
            <Button onClick={handleClose}>{t("Cancel")}</Button>
            <Button onClick={deleteReview} autoFocus>
              {t("Delete")}
            </Button>
          </DialogActions>
        </Dialog>

        <CleansingMenu />
        <Grid
          item
          md={8}
          sx={{
            pb: 2,
            pt: 2,
            display: "flex",
            flexDirection: "column",
            // border: "1px solid black",
          }}
        >
          <Box
            sx={{
              pt: 3,
              pb: 3,
              fontSize: "13px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <HashLink to={"/product/" + link + "#top"}>
              <KeyboardBackspaceIcon sx={{ paddingTop: "3px" }} />
            </HashLink>
            <HashLink to={"/product/" + link + "#top"}>
              &nbsp;{t("Go back to the product")}
            </HashLink>
          </Box>
          <Box sx={{ pt: 2, fontSize: "18px", color: "gray" }}>
            <span style={{ color: "#153a5a", fontWeight: 600 }}>{t(name)}</span>{" "}
            {t("Edit this review")}
          </Box>
          <Box sx={{ pt: 5, fontSize: "25px", pb: 3, color: "gray" }}>
            <Typography component="legend">
              {t("Change the review star")}
            </Typography>
            <Rating
              name="simple-controlled"
              precision={0.5}
              value={value}
              sx={{ fontSize: "32px" }}
              onChange={(event, newValue) => {
                setValue(newValue);
              }}
            />
          </Box>
          <TextField
            autoFocus
            id="filled-basic"
            label={t("Review Title*")}
            variant="filled"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            sx={{ width: 2 / 3, mt: 2 }}
          />
          <TextField
            placeholder={t("Provide a brief description*")}
            multiline
            variant="filled"
            rows={8}
            maxRows={8}
            sx={{ width: 2 / 3, mt: 2 }}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
          <Box sx={{ py: 3, pt: 4, color: "gray" }}>
            {t("Upload image(s) - maximum 3 images")}
          </Box>
          <input
            type="file"
            onChange={(e) => {
              upload(e.target.files[0]);
            }}
            style={{ width: "300px", cursor: "pointer" }}
          />
          {alert && (
            <Alert sx={{ width: "400px", mt: 2 }} severity="warning">
              {alert}
            </Alert>
          )}
          <Box sx={{ display: "flex" }}>
            {imageUrl && (
              <Box
                sx={{
                  pt: 2,
                  pr: 2,
                  display: "flex",
                  flexDirection: "column",
                  width: "100px",
                  // border: "1px solid black",
                  alignItems: "center",
                  color: "gray",
                }}
              >
                {imageUrl && (
                  <img src={imageUrl} alt="" width="100" height="100" />
                )}
                <Box
                  onClick={() => removeImage(imageUrl)}
                  sx={{ cursor: "pointer", pt: 2 }}
                >
                  {t("Remove")}
                </Box>
              </Box>
            )}

            {imageUrl2 && (
              <Box
                sx={{
                  pt: 2,
                  pr: 2,
                  display: "flex",
                  flexDirection: "column",
                  width: "100px",
                  // border: "1px solid black",
                  alignItems: "center",
                  color: "gray",
                }}
              >
                <img src={imageUrl2} alt="" width="100" height="100" />
                <Box
                  onClick={() => removeImage(imageUrl2)}
                  sx={{ cursor: "pointer", pt: 2 }}
                >
                  {t("Remove")}
                </Box>
              </Box>
            )}
            {imageUrl3 && (
              <Box
                sx={{
                  pt: 2,
                  pr: 2,
                  display: "flex",
                  flexDirection: "column",
                  width: "100px",
                  // border: "1px solid black",
                  alignItems: "center",
                  color: "gray",
                }}
              >
                <img src={imageUrl3} alt="" width="100" height="100" />
                <Box
                  onClick={() => removeImage(imageUrl3)}
                  sx={{ cursor: "pointer", pt: 2 }}
                >
                  {t("Remove")}
                </Box>
              </Box>
            )}
          </Box>
          <Box>
            <button
              // onClick={(e) => submit(e)}
              onClick={handleClickOpen}
              className="custom_btn_withOrangebg"
              style={{ width: "200px", marginTop: "30px", marginRight: "10px" }}
            >
              {t("Delete")}
            </button>
            <button
              onClick={(e) => submit(e)}
              className="custom_btn"
              style={{ width: "200px", marginTop: "30px" }}
            >
              {t("Edit")}
            </button>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default ModifyAReview;
